import { Product } from 'common/types/entities/api/product'
import { reloadSSProducts } from 'common/services/product'
import { WindowProduct } from 'common/types/entities/mongo/product'
import { RelationProductType } from 'common/constants/product/relationProductType'
import typeChecker from 'common/typeChecker'

export interface CoordiLayerState {
  products: Product[]
  relationProductType: RelationProductType
  showLayer: boolean
}

const initialState: CoordiLayerState = {
  products: [],
  relationProductType: RelationProductType.COORDI,
  showLayer: false,
}

const FETCH = 'coodi/products/FETCH'
const CLOSE_COORDI_LAYER = 'coodi/layer/CLOSE'
const INIT_COORDI_LAYER = 'coodi/layer/INIT'

export const addToBucket = (products: Product[]) => {
  return {
    products,
    type: FETCH,
  }
}

export const reloadAndAddToBucket = (
  productId: string,
  products: WindowProduct[],
  relationProductType: RelationProductType,
) => async dispatch => {
  const ids = products.map(product => product._id.toString())

  let newProducts = await reloadSSProducts(productId, ids)

  if (!newProducts) {
    return
  }

  if (newProducts && !typeChecker.isArray(newProducts)) {
    newProducts = [newProducts]
  }

  newProducts.forEach(ssProduct => {
    ssProduct.windowProduct = products.find(windowProduct => windowProduct._id.toString() === ssProduct.id.toString())
  })

  dispatch({
    relationProductType,
    products: newProducts,
    type: FETCH,
  })
}

export const closeCoordiLayer = () => {
  return {
    type: CLOSE_COORDI_LAYER,
  }
}

export const initCoordiLayer = () => {
  return {
    type: INIT_COORDI_LAYER,
  }
}

const coordiReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        products: [...action.products],
        relationProductType: action.relationProductType,
        showLayer: true,
      }
    case INIT_COORDI_LAYER:
    case CLOSE_COORDI_LAYER:
      return {
        products: [],
        showLayer: false,
      }
    default:
      return state
  }
}

export default coordiReducer
